module.exports = __webpack_public_path__ + "img/landing-map.bb1da36a.svg";